import { useEffect, useMemo, useState } from 'react';
import ModalComponent from '../../components/ModalComponent';

interface Props {
  defaultPageTitle: string
  open: boolean
  handleClose: () => void
  handleSave: (title: string) => void
}

const Index = (props: Props) => {
  const {
    defaultPageTitle, open, handleClose, handleSave,
  } = props;
  const [pageTitle, setPageTitle] = useState('');

  useEffect(() => {
    if (defaultPageTitle === '') {
      return;
    }

    setPageTitle(defaultPageTitle);
  }, [defaultPageTitle]);

  const title = useMemo(() => {
    if (defaultPageTitle === '') {
      return '新規ページ作成';
    }
    return 'ページタイトル変更';
  }, [defaultPageTitle]);

  // モーダルが閉じられた時に、タイトルをリセットします
  useEffect(() => () => {
    if (open) {
      return;
    }
    setPageTitle('');
  }, [open]);

  return (
    <>
      <ModalComponent
        title={title}
        confirmButtonText="保存する"
        onConfirm={() => handleSave(pageTitle)}
        disabled={pageTitle.length === 0}
        show={open}
        closeModal={() => {
          handleClose();
        }}
        centered
        backdrop="static"
        backdropClassName="z-index-2000"
        style={{ zIndex: 2001 }}
        keyboard={false}
        animation={false}
        isLackOfInfo={pageTitle.length === 0}
      >
        <p className="fs-xs">
          {defaultPageTitle
            ? (
                <>
                  ページタイトルを変更します
                  <br />
                  ページタイトルは、検索エンジンの検索結果などで表示されるテキストです。
                </>
            ) : (
              <>
                新規ページを作成いたします。
                <br />
                ページタイトルは、ページのtitleのタイトルになります。
                <br />
                また検索エンジンの検索結果などで表示されるテキストです。
              </>
            )}
        </p>
        <div className="d-flex gap-3">
          <label className="col-form-label text-sm-start fw-bold">ページタイトル</label>
          <div className="flex-fill">
            <input value={pageTitle} onChange={(e) => setPageTitle(e.target.value)} type="text" className="form-control" placeholder="マイページタイトル" />
          </div>
        </div>
      </ModalComponent>
    </>
  );
};

export default Index;
